import DEFINE from '../define';
import Free from './free';

export default class FreeLaser extends Free {

    name = DEFINE.TOOLS.FREE_LASER;

    laserPointerDuration = 1000;
    
    //雷射暈開效果強度
    laserBlur = 10;

    constructor(parent) {
        super(parent);
    }

    mouseDownBefore(o) {
        this.setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.LINE_SEGMENT);

        this.canvas.freeDrawingBrush.shadow = new fabric.Shadow({
            blur: this.laserBlur,
            offsetX: 0,
            offsetY: 0,
            affectStroke: true,
            color: `${this.setting.fill.slice(0, this.setting.fill.length - 1)},${this.setting.opacity} )`,
        });

        this.canvas.freeDrawingBrush.color = "rgba(255, 255 ,255, 1)";
        this.canvas.freeDrawingBrush.width = this.setting.strokeWidth;
    }

    objectAdded(o) {
        let target = o.target;

        if (this.getTotalLength(target.path) < this.lengthLimit / this.parent.viewportTransform.scale) {
            this.canvas.remove(target);
            this.canvas.renderAll();
        } else {
            target.animate('opacity', '0', {
                duration: this.laserPointerDuration,
                onChange: this.canvas.renderAll.bind(this.canvas),
                onComplete: function () {
                    this.canvas.remove(target);
                    this.canvas.renderAll();
                }.bind(this)
            })

            target.tag = DEFINE.TAG.FREE_LASER + new Date().getTime();
            target.toolType = this.name;
            target.transparentCorners = false;
            target.selectable = true;
            target.lockMovementX = true;
            target.lockMovementY = true;
            target.hasControls = false;
            target.hasBorders = false;
            target.perPixelTargetFind = true;

            this.canvas.renderAll();
        }
    }
}